import styled from 'styled-components'
import { themeGet } from 'styled-system'
import SortableAccordionList from 'components/SortableAccordionList'

export const BodyWrapper = styled.div`
  width: 100%;
  max-width: 1366px;
  box-sizing: border-box;
  padding: 0 1.25rem 2.25rem;
`

export const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const ContentPanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.1rem 1.25rem 0.5rem;
  box-sizing: border-box;
  border-radius: 0.625rem;
  background: ${themeGet('colors.white')};
  margin-right: 1rem;
`

export const StyledSortableAccordionList = styled(SortableAccordionList)`
  margin-right: 1.4rem;
  padding-left: 0.1rem;
  [class*='ListHeaderWrapper-sc'] {
    display: grid;
    grid-template-columns: 1.6fr 1fr 1fr 1fr 1fr 1.2fr;
    margin-bottom: 0.9375rem;
  }
`

// Header above the table (rendered via renderLeftBox)
export const HeaderTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`

export const HeaderTitle = styled.h1`
  margin: 0;
  font-family: ${themeGet('font.sharpSlab.semibold')};
  font-size: 1.438rem;
  line-height: 2rem;
  color: ${themeGet('colors.darkBlue')};
`

export const TierPill = styled.span`
  display: inline-flex;
  align-items: center;
  height: 1.5rem;
  padding: 0 0.5rem;
  border-radius: 1rem;
  background: ${themeGet('colors.aliceBlue')};
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('font.molde.medium')};
  font-size: 0.75rem;
  letter-spacing: 0.06em;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
  color: ${themeGet('colors.darkGray')};
  font-size: 1rem;
`

export const Pipe = styled.span`
  margin: 0 0.625rem;
`

export const YellowBullet = styled.span`
  display: inline-block;
  height: 0.8125rem;
  width: 0.8125rem;
  margin-top: -0.35rem;
  margin-right: 0.375rem;
  border-radius: 50%;
  background-color: ${themeGet('colors.yellow')};
  transform: translateY(0.0938rem);
`

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr 1fr 1.2fr;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  border: 2px solid
    ${themeGet('colors.backgrounds.secondary', 'colors.paleGray')};
  background: ${themeGet('colors.paleGray')};
  border-radius: 0.625rem;
  padding: 0.3rem 1.125rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover,
  &:focus {
    background-color: ${themeGet('colors.focusBackground')};
    outline: 2px solid ${themeGet('colors.blueGray')};
    outline-style: auto;
  }

  &:focus {
    outline-offset: 2px;
  }
`

export const Cell = styled.div`
  padding: 0.5rem 0;
  color: ${themeGet('colors.darkGray')};
`

export const Name = styled.div`
  font-size: 0.875rem;
  font-family: ${themeGet('font.molde.regular')};
  color: ${themeGet('colors.darkGray')};
  line-height: 1.3;
`

export const Group = styled.div`
  color: ${themeGet('colors.darkGray')};
  font-size: 1rem; /* 16px */
  line-height: 1.375rem; /* 22px */
  font-family: ${themeGet('font.molde.medium')};
`
